// extracted by mini-css-extract-plugin
module.exports = {"chatBubbleTopImage":"tabNosReults_chatBubbleTopImage__3MgF0","bubbleChatImageBottom":"tabNosReults_bubbleChatImageBottom__1fV_V","message":"tabNosReults_message__2lKLy"};